import "./login.css"
import loginImg from "../../../assets/register_img.webp";
import {useTranslation} from "react-i18next";
import {Link, useNavigate} from "react-router-dom";
import {setLoginInfo} from "../../../redux/login_store";
import {connect} from "react-redux";
import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import Alert from "react-bootstrap/Alert";
import React, {useEffect, useState} from "react";
import {setAppData} from "../../../redux/register_store";
import {setPersonalData} from "../../../redux/personal_store";
import {setFinancialInfo} from "../../../redux/financial_store";
import {setAffiliationField} from "../../../redux/affiliation_store";
import {setExpInfoData} from "../../../redux/experience_store";
import {setConditionInfo} from "../../../redux/conditions_store";
import {setCustodialData} from "../../../redux/custodial_acc_store";
import {setOwnerData} from "../../../redux/owner_info_store";
import {setAuthInfo} from "../../../redux/auth_singer_store";
import {setVerifyInfo} from "../../../redux/verify_password_store";
import apiClient from "../../../utils/axios";

const HOST = `${process.env.REACT_APP_API_URL}/api/accounts/user`
const URL = `${process.env.REACT_APP_API_URL}/api/accounts/resetpassword`

function Login({
                   login,
                   setLoginInfo,
                   updateResponse,
                   setAppData,
                   setPersonalData,
                   setFinancialInfo,
                   setAffiliationField,
                   setExpInfoData,
                   setConditionInfo,
                   setCustodialData,
                   setOwnerData,
                   setAuthInfo,
                   setVerifyInfo
               }) {

    const navigate = useNavigate()

    const [showAlert, setShowAlert] = useState(false);
    const [successAlert, setSuccessAlert] = useState(false)
    const [, setShowForgotPassword] = useState(false);
    const [currentPage, setCurrentPage] = useState("login");
    const [loginError, setLoginError] = useState("");
    const {t} = useTranslation()

    const [resetErrors, setResetErrors] = useState({
        email: ""
    })

    const handleSubmit = (e) => {
        e.preventDefault();

        let isValid = true;

        if (isValid) {
            loginApp()
        }
    };

    const handleResetSubmit = (e) => {
        e.preventDefault();

        setResetErrors({
            email: '',
        })

        let isValid = true;

        if (!login.email) {
            setResetErrors((prevErrors) => ({
                ...prevErrors,
                email: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (isValid) {
            try {
                resetPass()
            } catch (error) {
                setResetErrors((prevErrors) => ({
                    ...prevErrors,
                    submitError: error.message,
                }));
            }
        }
    }

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setLoginError("");
        setLoginInfo({...login, [name]: value});
    };

    useEffect(() => {
        if (showAlert) {
            const timer = setTimeout(() => {
                setShowAlert(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [showAlert]);

    useEffect(() => {
        if (successAlert) {
            const timer = setTimeout(() => {
                setSuccessAlert(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [successAlert]);

    const loginApp = async () => {
        try {
            const response = await apiClient.post(HOST, {...login});

            if (response.data[0]) {
                if (response.data.token) {
                    localStorage.setItem("auth_token", response.data.token);
                }
                updateResponse(response.data);
                navigate('/welcome-back');
            } else {
                setShowAlert(true);
            }
        } catch (error) {
            if (error.response && error.response.data?.error) {
                setLoginError(error.response.data.error);
            } else {
                setLoginError(t('errors.something_went_wrong'));
            }
        }
    };

    const resetPass = async () => {
        try {
            const response = await apiClient.post(URL, login, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            });

            if (response.data.status === '404') {
                setShowAlert(true);
            } else {
                setSuccessAlert(true);
            }

            if (response.data && response.data.status &&
                ['400', '401', '403', '404', '405', '408', '419', '429', '500', '501', '502', '503', '504', '505'].includes(response.data.status)) {
                throw new Error(response.data.message || 'Unknown error occurred');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleForgetPasswordClick = () => {
        setShowForgotPassword(true);
        setCurrentPage("forgotPassword");
    };

    const handleCancelClick = () => {
        setShowForgotPassword(false);

        localStorage.clear();
        sessionStorage.clear();

        setAppData({
            account_type: 'individual',
            sub_account_type: '',
            email: '',
            password: '',
            confirm_password: '',
            hear_about_us: '',
            citizenship_status: '',
            app_id: '',
            specialtyAccountType: 'C',
            country_of_birth: '',
            country_of_residence: '',
            country_of_citizenship: '',
            clientIP: ''
        })
        setPersonalData({
            title: '',
            firstName: '',
            lastName: '',
            middleName: '',
            birth: '',
            ssn: '',
            confirmSsn: '',
            phone: '',
            maritalStatus: '',
            idenType: '',
            idenNumber: '',
            issueDate: '',
            expDate: '',
            permAddress: '',
            address2: '',
            city: '',
            country: '',
            zipCode: '',
            state: '',
            mailingCountry: '',
            mailingAddress: '',
            mailingAddress2: '',
            mailingCity: '',
            mailingZipCode: '',
            mailingState: '',
            trustName: '',
            trustCountry: '',
            mailingDiff: ''
        });
        setFinancialInfo({
            emplStatus: '',
            sourceOfIncome: '',
            sourceOfWealth: '',
            annualIncome: '',
            assets: '',
            netWorth: '',
            schoolName: '',
            occupation: '',
            companyName: '',
            businessState: '',
            businessAddress: '',
            city: '',
            zipCode: '',
            countryName: '',
            businessPhone: '',
            soldBusinessName: '',
            soldAmount: '',
            soldBusinessDate: ''
        })
        setAffiliationField({
            questions: [
                {
                    id: 1,
                    name: 'AffiliationMember',
                    text: 'affiliation.are_member',
                    selected: false
                },
                {
                    id: 2,
                    name: 'AffiliationBroker',
                    text: 'affiliation.NFA_or_CFTC',
                    selected: false
                },
                {
                    id: 3,
                    name: 'AffiliationForShellBank',
                    text: 'affiliation.foreign_shell',
                    selected: false
                },
                {
                    id: 4,
                    name: 'AffiliationShellBank',
                    text: 'affiliation.owner_affiliated',
                    selected: false
                },
                {
                    id: 5,
                    name: 'AffiliationShellBankService',
                    text: 'affiliation.owner_offer',
                    selected: false
                },
                {
                    id: 6,
                    name: 'AffiliationBankrupt',
                    text: 'affiliation.bankruptcy_proceeding',
                    selected: false
                },
                {
                    id: 7,
                    name: 'AffiliationLegal',
                    text: 'affiliation.commodity_account',
                    selected: false
                },
                {
                    id: 8,
                    name: 'AffiliationUnpaid',
                    text: 'affiliation.commodity_firm',
                    selected: false
                },
                {
                    id: 9,
                    name: 'AffiliationOtherFunds',
                    text: 'affiliation.business_with_you',
                    selected: false
                },
                {
                    id: 10,
                    name: 'AffiliationFFI',
                    text: 'affiliation.financial_institution',
                    selected: false
                },
                {
                    id: 11,
                    name: 'AffiliationPoliOfficial',
                    text: 'affiliation.close_associate',
                    selected: false
                }
            ],
            name: '',
            process: '',
            position: '',
            affPerson: '',
            companyName: '',
            organizations: '',
            memberPosition: '',
            memberAffPerson: '',
            memberCompanyName: ''
        })
        setExpInfoData({
            stockYear: '',
            stockAverageSize: '',
            stockAverageNumber: '',
            optionYear: '',
            optionAverageSize: '',
            optionAverageNumber: '',
            invest_obj: ''
        })
        setConditionInfo({
            customer: false,
            margin: false,
            option: false,
            taxPlayer: false,
            clear: true,
            agreew8: false,
            disclosure: false,
            privacy: true,
            agreeConfirm: true,
            agreeEstatement: true,
            agreeProxy: true,
            agreePros: true,
            agreeEtax: true,
            finder: false
        })
        setLoginInfo({
            email: '',
            password: ''
        })
        setCustodialData({
            custodial_first_name: '',
            custodial_last_name: '',
            custodial_middle_name: '',
            custodial_ssn: '',
            custodial_birth: '',
            custodial_type: 'UTMA'
        })
        setOwnerData({
            joint_title: '',
            joint_first_name: '',
            joint_last_name: '',
            joint_middle_name: '',
            joint_birth: '',
            joint_citizenship_status: '',
            joint_ssn: '',
            joint_confirm_ssn: '',
            joint_iden_type: '',
            joint_iden_number: '',
            joint_issue_date: '',
            joint_exp_date: '',
            joint_spouse: 'N',
            joint_same_add: 'Y',
            joint_mobile_phone: '',
            joint_home_phone: '',
            joint_emp_status: '',
            joint_member: 'N',
            joint_indicate1: '',
            joint_indicate2: '',
            joint_occupation: '',
            joint_company_name: '',
            joint_address: '',
            joint_city: '',
            joint_business_country: '',
            joint_business_state: '',
            joint_zip_code: '',
            joint_school_name: '',
            joint_no_address: '',
            joint_no_address2: '',
            joint_no_city: '',
            joint_no_country: '',
            joint_no_zip_code: '',
            country_of_birth: '',
            country_of_residence: '',
            country_of_citizenship: '',
            joint_no_state: ''
        })
        setAuthInfo([{
            checked: false,
            auth_title: '',
            auth_first_name: '',
            auth_middle_name: '',
            auth_last_name: '',
            auth_entity_role: ''
        }])
        setVerifyInfo({
            email: "",
            new_password: "",
            confirm_new_password: "",
        })
        setCurrentPage("login");
    };

    return (
        <div>
            <Header/>
            <div className="flex">
                <div className="left_side">
                    <img className="w-full" src={loginImg} alt=""/>
                </div>
                <div className="right_side">
                    {currentPage !== "login" ? (
                        <form onSubmit={handleResetSubmit}>
                            <div className="pt-8">
                                <p className="login_heading text-center font-normal text-5xl">
                                    {t('login.forgot_password')}
                                </p>
                                <p className="text-center">{t('login.retrieve_password')}</p>
                                <div className="flex flex-column gap-3 align-items-center pt-2">
                                    <input
                                        value={login.email}
                                        name="email"
                                        onChange={handleInputChange}
                                        type="email"
                                        className="login_email w-full flex align-items-center p-2 gap-2"
                                        placeholder={t('login.enter_email')}
                                    />
                                    {resetErrors.email && <p className="error">{resetErrors.email}</p>}
                                </div>
                                <div className="pt-4">
                                    {showAlert && (
                                        <Alert variant="danger">
                                            {t('login.user_not_found')}
                                        </Alert>
                                    )}

                                    {successAlert && (
                                        <Alert variant="success">
                                            {t('login.send_message')}
                                        </Alert>
                                    )}
                                </div>
                                <div
                                    className="flex justify-content-center align-items-center gap-4 sm:flex-row flex-column row-gap-3 pt-6">
                                    <button type="submit"
                                            className="login_btn w-10rem flex justify-content-center align-items-center gap-2 text-white border-0 font-bold no-underline sm:text-xl text-base px-1 py-2 border-round-sm"
                                    >
                                        {t('login.login')}
                                    </button>
                                    <Link to="/login" className="no-underline">
                                        <button
                                            className="cancel_btn w-10rem flex justify-content-center align-items-center gap-2 text-white border-0 font-bold no-underline sm:text-xl text-base px-1 py-2 border-round-sm"
                                            onClick={handleCancelClick}>
                                            {t('login.cancel')}
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </form>

                    ) : (
                        <form onSubmit={handleSubmit}>
                            <div className="pt-8">
                                <p className="login_heading text-center font-normal text-5xl">{t('login.login')}</p>
                                <div className="flex flex-column gap-3 align-items-center pt-2">
                                    <input
                                        value={login.email}
                                        name="email"
                                        onChange={handleInputChange}
                                        type="email"
                                        className="login_email w-full flex align-items-center p-2 gap-2"
                                        placeholder={t('login.enter_email')}
                                    />
                                    <input
                                        value={login.password}
                                        name="password"
                                        onChange={handleInputChange}
                                        type="password"
                                        className="login_password w-full flex align-items-center p-2 gap-2"
                                        placeholder={t('login.enter_password')}
                                    />
                                </div>
                                <div className="pt-4">
                                    {showAlert && (
                                        <Alert variant="danger">
                                            {t('login.acc_not_found')}
                                        </Alert>
                                    )}
                                </div>
                                <div
                                    className="flex justify-content-center align-items-center gap-4 sm:flex-row flex-column row-gap-3 pt-6">
                                    <button type="submit"
                                            className="login_btn w-10rem flex justify-content-center align-items-center gap-2 text-white border-0 font-bold no-underline sm:text-xl text-base px-1 py-2 border-round-sm">
                                        {t('login.login')}
                                    </button>
                                    <Link to="/" className="no-underline">
                                        <button
                                            className="cancel_btn w-10rem flex justify-content-center align-items-center gap-2 text-white border-0 font-bold no-underline sm:text-xl text-base px-1 py-2 border-round-sm"
                                            onClick={handleCancelClick}>
                                            {t('login.cancel')}
                                        </button>
                                    </Link>
                                </div>
                                <p onClick={handleForgetPasswordClick}
                                   className="forgot_password text-center font-bold pt-3 cursor-pointer text-base"
                                >
                                    {t('login.forget_password')}
                                </p>
                            </div>

                            <div>
                                {resetErrors.submitError && (
                                    <div className="text-red-500 text-center">
                                        {resetErrors.submitError}
                                    </div>
                                )}
                            </div>
                            <div className="pt-4">
                                {loginError && (
                                    <div className="text-red-500 text-center">
                                        {loginError}
                                    </div>
                                )}
                            </div>
                        </form>
                    )}
                </div>
            </div>
            <Footer/>
        </div>
    )
}

const mapStateToProps = (state) => ({
    login: state.login,
});

const mapDispatchToProps = {
    setLoginInfo,
    setAppData,
    setPersonalData,
    setFinancialInfo,
    setAffiliationField,
    setExpInfoData,
    setConditionInfo,
    setCustodialData,
    setOwnerData,
    setAuthInfo,
    setVerifyInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);